import { property } from 'lodash-es';
import { pending } from '@updater/redux-http-request';

export const reducer = pending.reducer;
export const selectors = pending.selectors(property('pending'));
